module.exports = __webpack_public_path__ + "static/media/fdsu.6d1e3c29.png";